/* eslint-disable */
// Copyright (c) 2025 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { EMPTY_OBJECT } from '../../../constants/globalConstants'
function SupportButton(props) {
  const { partnerDetails, isAppStore } = props
  const [showFallback, setShowFallback] = useState(false)
  const [copied, setCopied] = useState(false)

  //   const currentURL = window?.location?.toString() || ''
  let email = partnerDetails?.brand_setting?.support_email || 'support@parkengage.com'

  //   if (currentURL.includes('parkpayride')) {
  //     email = 'support@parkpayride.com'
  //   } else if (currentURL.includes('park2visit')) {
  //     email = 'support@park2visit.com'
  //   }

  const handleClick = () => {
    window.location.href = `mailto:${email}?subject=Support%20Request`
    setCopied(false)
    setTimeout(() => {
      setShowFallback(true)
    }, 3000)
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(email)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  const handleCloseFallback = () => {
    setShowFallback(false)
    setCopied(false)
  }

  return (
    <>
      <a className={`text-decoration-none email-support-btn ${isAppStore ? 'app-store' : ''}`} onClick={handleClick}>
        Need Help?
      </a>

      {showFallback && (
        <div className={`email-fallback ${isAppStore ? 'app-store-fallback' : ''}`}>
          <button className="close-fallback" onClick={handleCloseFallback}>×</button>
          <span>{email}</span>
          <button className='bg-white' onClick={handleCopy}>
            {copied ? <i className="fa fa-copy text-success"></i> : <i className="fa fa-copy text-grey"></i>}
          </button>
        </div>
      )}
    </>
  )
}

SupportButton.propTypes = {
  partnerDetails: PropTypes.object,
  isAppStore: PropTypes.bool
}

SupportButton.defaulProps = {
  partnerDetails: EMPTY_OBJECT,
  isAppStore: false
}



export default connect()(SupportButton)